import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {AudioRecordModel} from '../../../../record/api/model/audioRecord.model';
import {AudioRecordingComponent} from '../../../../record/api/component/audio-recording/audio-recording.component';
import {environment} from '../../../../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DialogController} from "../../../../../dialog/dialogController";
import {AudioTranscriptionService} from "./audio-transcription.service";
import {
  AudioTranscriptionDialogComponent,
  AudioTranscriptionDialogInput, AudioTranscriptionDialogOutput
} from "../audio-transcription-dialog/audio-transcription-dialog.component";

@Component({
  selector: 'app-audio-transcription',
  templateUrl: './audio-transcription.component.html',
})
export class AudioTranscriptionComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() config: TranscriptionConfig;
  @Output() transcriptionSavedEvent = new EventEmitter<number>();
  @Output() audioRecordedEvent = new EventEmitter<AudioRecordModel>();
  @Output() transcriptionEndedEvent = new EventEmitter<string>();
  @Output() transcriptionStartedEvent = new EventEmitter<void>();
  @Output() transcriptionValidatedEvent = new EventEmitter<string>();
  @ViewChild('audioRecordingComponent') audioRecordingComponent: AudioRecordingComponent;

  socket: WebSocket;
  transcriptionService: AudioTranscriptionService;

  validationFormGroup: FormGroup;
  constructor(private formBuilder: FormBuilder,
              private dialogController: DialogController) {
    this.validationFormGroup = this.formBuilder.group({
      transcription: new FormControl(undefined, Validators.required)
    });
  }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    // console.log(['auto start', this.config]);
    if (this.config.startAutomatically) {
      this.startTranscription();
    }
  }

  ngOnDestroy() {
    this.closeSocket();
  }

  startTranscription() {
    this.transcriptionStartedEvent.emit();
    if (this.socket) {
      this.closeSocket();
    }
    if (!this.config) {
      return;
    }
    let prefix = 'ws://';
    if (environment.webserviceUrl.indexOf('https://') === 0) {
      prefix = 'wss://';
    }

    this.socket = new WebSocket(prefix +
        environment.webserviceUrl.replace('http://', '')
            .replace('https://', '') + '/speech?audioContentValue=' +
        this.config.audioContentValue + '&context=' + this.config.context);
    this.socket.onopen = event => {
      // console.log('Audio transcription websocket opened');
      this.audioRecordingComponent.startRecording();
      this.transcriptionService = new AudioTranscriptionService();
      const input: AudioTranscriptionDialogInput = {
        stopRecordingTooltip: 'Arrêter la retranscription',
        service: this.transcriptionService
      };
      this.dialogController.open(AudioTranscriptionDialogComponent, input, {
        title: 'Retranscription audio',
        width: '95%',
      }).afterClosed().toPromise()
          .then((result: AudioTranscriptionDialogOutput) => {
            if (result) {
              this.audioRecordingComponent.stopRecording(true);
              this.transcriptionEndedEvent.emit(result.text);
            }
            this.stopTranscription();
          });
    };
    this.socket.onclose = event => {
      this.audioRecordingComponent.stopRecording(false);
    };
    this.socket.onerror = event => {
      this.closeSocket();
      this.audioRecordingComponent.stopRecording(false);
    };
    this.socket.onmessage = event => {
      // console.log(event.data);
      if (event.data) {
        // console.log((event.data as string)?.indexOf('id='));
        if ((event.data as string)?.indexOf('id=') === 0) {
          // console.log('Id received' + Number((event.data as string)?.replace('id=', '')));
          this.transcriptionSavedEvent.emit(Number((event.data as string)?.replace('id=', '')));
        } else {
          this.transcriptionService.setTranscription(event.data);
        }
      }
    };

  }
  stopTranscription() {
    // console.log('Stop audio transcription');
    if (this.isSocketOpen()) {
      this.socket.send('STOP');
    }
  }

  audioChunkRecorded(chunk: Blob) {
    this.blobToBase64(chunk).then((base64) => {
      if (this.isSocketOpen()) {
        this.socket.send(base64.replace('data:audio/webm;codecs=opus;base64,', ''));
      }
    });
  }

  closeSocket() {
    if (this.isSocketNotClosedOrClosing()) {
      try {
        this.socket.close();
      } catch (e) {
        console.log(e);
      }
    }
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.readAsDataURL(blob);
    });
  }

  isSocketOpen() {
    return this.socket && this.socket.readyState === WebSocket.OPEN;
  }
  isSocketNotClosedOrClosing() {
    return this.socket && this.socket.readyState !== WebSocket.CLOSED && this.socket.readyState !== WebSocket.CLOSING;
  }

  validateTranscription() {
    this.transcriptionValidatedEvent.emit();
  }
}

export class TranscriptionConfig {
  context: string;
  audioContentValue: string;
  startAutomatically = false;
}

